import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ASSET_PATH } from 'assetsPath';
import {
	HotelTileContainer, DestinationListItemTop, ItemTopPlaceHolder, HotelTileWrap,
	ItemTopImage, HiglightedTag, HiglightedTagSide, HiglightedTagContent, TopPlaceName, AmentiesDot, HotelDataWrapper
} from './HotelTilesStyle';
import Button from 'common/Button/Button';
import { FlexDiv, GenericDiv, GenericP } from 'common/Styles';
import StarRating from 'common/StarRating/StarRating';
import { MODAL_TYPE } from '../../../../config';
import { showModal } from 'reduxStore/actions/miceActionDispatcher';
import { trackMiceClick } from 'UtilityComponents/miceUtils';
import { processImgParams } from 'UtilityComponents/Util';
import PriceComponent from '../PriceComponent/PriceComponent';
import { PriceText } from '../PriceComponent/PriceComponentStyles';

const defaultStar = ASSET_PATH.IMAGES + '/star_default.png';
const SelectedStar = ASSET_PATH.IMAGES + '/star_selected.png';

const HotelTile = ({ isMobile, property }) => {
	const dispatch = useDispatch();
	const hotelSearchData = useSelector((state) => state.mice.hotelSearchData);
	const { hotels = [] } = hotelSearchData || {};
	const selectProp = useMemo(() => hotels.filter((htl) => !!htl.name && !!property && htl.name.toLowerCase().includes(property.toLowerCase()))[0], [property, hotels]);

	const getQuoteTiles = (item) => {
		const { amenities, area, bestPoi, name, starRating } = item;
		return (
			<GenericDiv left_P='16' right_P='16' top_P='12'>
				{starRating && <StarRating
					defaultStarImg={defaultStar}
					activeStarImg={SelectedStar}
					iconWidth={11}
					iconHeight={11}
					starValue={starRating}
					margin='0 0 6px 0'
				/>}
				<GenericP fsize='18px' f_weight='900' color='#000' justify='flex-start'>
					{name && <span>{name} </span>}
				</GenericP>
				{isMobile &&
					<GenericDiv top_M='5'>
						<PriceComponent isTile display='block' item={item} isMobile toOpenModal />
					</GenericDiv>}
				<HotelDataWrapper isMobile={isMobile}>
					<GenericDiv top_M='5' width={isMobile && '100%'}>
						<GenericP fsize='12px' color='#9b9b9b'>
							{area && <span>{area}</span>}
							{area && bestPoi && <span> | </span>}
							{bestPoi && bestPoi}
						</GenericP>
						<GenericP top_M='5'>
							{amenities?.length > 0 && amenities.map((itm, index) => (
								<React.Fragment key={index}>
									<PriceText key={index} display={isMobile && 'flex'} fsize='12px'>
										<AmentiesDot topPos={isMobile} />
										{itm}
									</PriceText>
								</React.Fragment>
							))}
						</GenericP>
					</GenericDiv>
					{!isMobile &&
						<GenericDiv left_M='4' top_M='5'>
							<PriceComponent isTile display='block' item={item} />
						</GenericDiv>}
				</HotelDataWrapper>
			</GenericDiv>
		);
	};

	const dropQueryTile = (item) => {
		const { imgText } = item;
		return (
			<DestinationListItemTop>
				<ItemTopPlaceHolder>
					{imgText}
				</ItemTopPlaceHolder>
			</DestinationListItemTop>
		);
	};

	const handler = (isDropQuery, item) => () => {
		let payload = {
			modalType: MODAL_TYPE.QUERY_FORM,
			modalData: {
				selectedHotelData: item
			}
		};
		const trackVal = isDropQuery ? 'query_clicked' : `${item.name}_${item.area}_query_clicked`;
		trackMiceClick(trackVal);
		dispatch(showModal(payload));
	};

	useEffect(() => {
		if (selectProp) {
			handler(false, selectProp)();
		}
	}, [property, selectProp]);

	return (
		<HotelTileContainer wrap='wrap' justify='space-between' top_P='24'>
			{hotels && hotels.map((item, index) => {
				const { name, images, isDropQuery, heading, highlightedText, city } = item;
				return (
					<HotelTileWrap
						className={highlightedText && 'highlighted-tile'}
						directionInMobile='column'
						direction='column'
						justify='space-between'
						key={name}>
						<GenericDiv>
							{images &&
								<DestinationListItemTop>
									<ItemTopImage src={processImgParams(images[0], isMobile, { ratio: 2.2, initWidth: 1000 })} alt={heading} />
									{city &&
										<TopPlaceName className='destinationListItem-top_placeName'>{city}</TopPlaceName>}
									{highlightedText &&
										<HiglightedTag>
											<HiglightedTagSide className='popularTag-side' />
											<HiglightedTagContent className='popularTag-content'>{highlightedText}</HiglightedTagContent>
										</HiglightedTag>}
								</DestinationListItemTop>}
							{isDropQuery && dropQueryTile(item)}
							{isDropQuery ?
								<GenericP fsize='12px' color='#4a4a4a' top_P='5' left_P='16' right_P='16'>
									{heading}
								</GenericP> : getQuoteTiles(item, index)}
						</GenericDiv>
						<FlexDiv top_M='16' align='flex-end' left_P='16' right_P='16' top_P='16' bottom_P='16'>
							<Button
								btnTxt='DROP A QUERY'
								btnType='Flat'
								btnName='Secondary'
								btnShadow
								handleClick={handler(isDropQuery, item)}
								btnWidth='100%'
							/>
						</FlexDiv>
					</HotelTileWrap>
				);
			})}

		</HotelTileContainer>
	);
};

export default HotelTile;
